import { Button, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React from 'react';
import { useNavigate } from 'react-router-dom';

function GoBack({ title = null, onBack = null }) {
  const navigate = useNavigate();

  const onPress = (event) => {
    event.preventDefault();
    navigate(-1);
  };

  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: '1rem',
      }}
    >
      <Button onClick={onBack ? onBack : onPress}>
        <ArrowBackIcon
          sx={{
            color: 'black',
            fontSize: '60px',
            width: '30px',
            height: '30px',
          }}
        />
      </Button>

      {title && (
        <Typography
          variant='h5'
          sx={{
            fontWeight: 'bold',
          }}
        >
          {title}
        </Typography>
      )}
    </Stack>
  );
}

export default GoBack;
